const tr = {
  updateSuccess: '更新成功',
  updateFailed: '更新失敗',
  delOrgSuccess: '刪除組織成功,為您切換下一個組織。',
  delOrgFailed: '刪除組織失敗',
  addSuccess: '添加成功',
  addFailed: '新增失敗',
  authSetSuccess: '權限設定成功，請重新整理頁面查看。',
  authSetFailed: '權限設定失敗',
  disblMemSuccess: '禁用成員成功',
  disblMemFailed: '禁用成員失敗',
  viewOrgRepo: '組織倉庫查看',
  fullPermissions: '全部權限',
  editOrgDetails: '組織詳情修改',
  manageSubOrgs: '下級組織管理',
  manageOrgMems: '組織成員管理',
  manageOrgDetailsMems: '組織詳情以及成員管理',
  orgRepoInbound: '組織倉庫(入庫)',
  orgRepoOut: '組織倉庫(出庫)',
  manageSubOrgRepos: '下級組織倉庫管理(出入庫)',
  manageSubOrgAndMeb:'下級組織以及成員管理',
  mobileNumber: '手機號碼',
  purview: '所屬權限',
  avatar: '頭像',
  phNumber: '手機號',
  setPermissions: '權限設定',
  disable: '停用',
  enable: '啟用',
  thisMember:'該成員嗎',
  delOrgTip1: '確定刪除該組織嗎？',
  delOrgTip2: '刪除該組織後組織資訊無法恢復，並且該組織下的用戶也會移除，是否確認刪除？',
  createNewMem: '建立新成員',
  selPerson: '請選擇人員',
  orgInfo: '組織詳情',
  addOrg: '添加組織',
  addSubOrgBut: '添加下級組織',
  members: '成員',
  noMem: '暫無成員',
  name: '名稱',
  orgNameRequired: '組織名稱不能為空!',
  desc: '描述',
  cancel: '取消',
  memList: '成員列表',
  addOrgMem: '新增組織成員',
  selMem: '請選擇成員',
  setMemPurview: '設定成員({{userName}})權限',
  memDetails: '成員詳情',
  prompt: '提示',
  conAction: '您確定要',
  enterName: '請輸入名稱',
  enterDesc: '請輸入描述',
  managOrgUser: '系統管理/system manager,manager org|user',
  editOrgBasicInfo: '組織基本資訊修改',
  manageOrgUsers: '組織user管理',
  manageOrgProfile: '組織profile管理',
  inboundManag: '入庫管理',
  outboundManag: '出庫管理',
  manageSubInv: '下級庫存管理',
  unPurview:'未知權限',
  plEnterOrgName: '請輸入組織名稱',
  addOrgStru: '添加組織機構',
  noMove: '禁止同層級移動',
  addSubOrg: '添加({{name}})的下級組織',  
  noData: '暫無數據',
  delOrgTip3: "該組織存在下級組織，請先刪除下級組織再刪除。",
  orgMoveSuc: "組織移動成功",
  orgMoveFail: "組織移動失敗",
  selectAll: "全選",
  userNoOrg: "用戶無參與組織，將在5秒後登出。",
  cancelTip: "當前已選擇人員，確認取消嗎？",
  delOrg: "刪除組織",
  plEnterUserName: "請輸入Name1、Name2、手機號進行蒐索",
  noOrgData: "暫無找到該組織數據/組織可能被刪除",
  orgFetchFail: '獲取組織資訊失敗',
  orgListEmpty: "當前暫無組織，請先添加組織。",
  selectOrg: "請先選擇組織",
  orgDisabled: "組織已被禁用或不存在",
  modifyOrgInfo: "修改組織信息",
  addOrDisableOrgMember: "添加/禁用組織成員",
  orgMemberPermissions: "設置組織成員權限",
};

export default tr;